import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import thank_you_desktop from '@/shared/images/Images/thank_you_desktop.jpg';
import thank_you_desktopDark from '@/shared/images/Images/thankyou_desktopdark.png';
import thank_you_mobileDark from '@/shared/images/Images/thankyou_mobiledark.png';

export const Wrapper = styled.div`
    min-height: calc(100vh - 50px);
    padding-bottom: 28px;
    ${Screen.ipad} {
        padding-bottom: 36px;
    }

    ${Screen.desktop} {
        padding-bottom: 48px;
    }
`;

export const Container = styled.div`
    position: relative;
    ${Screen.desktop} {
        width: 1064px;
        margin: 0 auto;
    }
`;

export const ContentContainer = styled.div`
    padding: 0 20px;
    ${Screen.desktop} {
        padding: 0 30px;
    }
`;

export const OrderPageWrapper = styled.div`
    padding: 0 0 30px;
    ${Screen.desktop} {
        padding: 0 0 60px;
    }
`;

export const Price = styled.h3`
    color: ${cssVars.fg_gray1_white};
    text-align: center;
    ${Screen.desktop} {
        ${Text.Desktop.heading3};
    }
`;

export const Title = styled.h2`
    color: ${Palette.green.normal};
    text-align: center;
    ${Screen.desktop} {
        ${Text.Desktop.large.medium};
    }
`;

export const Divider = styled.div`
    border: 1px solid ${cssVars.fg_white_dark};
    margin: 70px auto 124px;
    width: 274px;

    ${Screen.desktop} {
        width: 65vw;
    }
`;

export const DividerWrapper = styled.div`
    width: 274px;
    margin: 0 auto;
    ${Screen.desktop} {
        width: 65vw;
    }
`;

export const LeftRound = styled.div`
    position: relative;
    display: block;
    padding-bottom: 24px;
    text-align: left;
    &::before {
        position: absolute;
        bottom: 140px;
        content: '';
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${cssVars.fg_white_dark};
    }
`;

export const CenterRound = styled.div`
    position: relative;
    display: block;
    padding-bottom: 24px;
    text-align: center;
    &::before {
        position: absolute;
        bottom: 165px;
        content: '';
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${cssVars.fg_white_dark};
    }
`;

export const RightRound = styled.div`
    position: relative;
    display: block;
    padding-bottom: 24px;
    text-align: right;
    &::before {
        position: absolute;
        bottom: 172px;
        left: 29.5vw;
        ${Screen.desktop} {
            left: 63.7vw;
        }
        content: '';
        width: 51px;
        height: 51px;
        border-radius: 50%;
        opacity: 0.3;
        background-color: ${Palette.green.normal};
    }

    &::after {
        position: absolute;
        bottom: 188px;
        content: '';
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${Palette.green.normal};
    }
`;

export const TextWrapper = styled.div`
    position: relative;
    bottom: 15vh;
    display: flex;
    justify-content: space-between;
`;

export const LeftRoundText = styled.div`
    color: ${cssVars.fg_gray1_white};
`;

export const CenterRoundText = styled.div`
    color: ${cssVars.fg_gray1_white};
`;

export const RightRoundText = styled.div`
    color: ${cssVars.fg_gray1_white};
`;

export const ThankyouImage = styled.div<{ themeColor: string | boolean }>`
    width: 291px;
    height: 145px;
    ${Screen.desktop} {
        width: 692.58px;
        height: 349px;
    }
    margin: 0 auto;
    background-image: ${({ themeColor }) =>
        themeColor == 'light'
            ? `url(${thank_you_desktop.src})`
            : Screen.desktop
            ? `url(${thank_you_desktopDark.src})`
            : `url(${thank_you_mobileDark.src})`};
`;

export const ImportantInfoWrapper = styled.div`
    box-shadow: 0px 3.89312px 23.3587px rgba(189, 189, 189, 0.23);
    border-radius: 15px;
    background: ${cssVars.bg_white_dark3};
    margin: 71px 0;
    padding: 71px 15px;

    ${Screen.desktop} {
        padding: 71px;
    }
`;

export const ImportantInfoTitle = styled.div`
    background: ${cssVars.bg_ash_dark2};
    border-radius: 15px;

    ${Screen.desktop} {
        width: 923px;
        height: 100px;
        text-align: center;
        padding: 4% 0;
        ${Text.Desktop.heading4};
        color: ${cssVars.fg_gray_dark};
    }
`;

export const InfoWrapper = styled.div`
    margin: 42px auto;
`;

export const InfoSteps = styled.div`
    ${Text.Mobile.large.semibold};
    color: ${cssVars.fg_gray2_white};
`;

export const InfoStepsDetails = styled.div`
    ${Text.Desktop.medium.regular};
    color: ${cssVars.fg_gray2_white};
    margin: 0 0 30px;
`;
